import { getFunctionUrl } from "../config";
import { getAuthToken } from "./auth";

type AdminErrorBody = {
  message?: string;
  error?: string;
};

function parseAdminError(value: unknown): AdminErrorBody {
  if (!value || typeof value !== "object" || Array.isArray(value)) return {};
  const record = value as Record<string, unknown>;
  return {
    message: typeof record.message === "string" ? record.message : undefined,
    error: typeof record.error === "string" ? record.error : undefined,
  };
}

async function postAdmin<T>(
  path: string,
  payload: Record<string, unknown>,
): Promise<T> {
  const token = await getAuthToken();
  if (!token) throw new Error("Niet ingelogd.");
  const response = await fetch(getFunctionUrl("dbvdw-admin", path), {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
  const data: unknown = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = parseAdminError(data);
    throw new Error(error.message || error.error || `Fout ${response.status}`);
  }
  return data as T;
}

export const adminApi = {
  sendInvitation: (payload: Record<string, unknown>) =>
    postAdmin<{ invitation_id: string; status: string }>(
      "/invitations",
      payload,
    ),
  recoverInvitation: (payload: Record<string, unknown>) =>
    postAdmin<{ actor_id: string; status: string }>(
      "/invitations/recover",
      payload,
    ),
};
